import React, { useState } from 'react';
import AddressForm from '@/components/AddressBook/AddressForm';
import AddressList from '@/components/AddressBook/AddressList';
import AddCompany from '@/components/AddressBook/NewAddressForm';

const AddressBooking = () => {
    const [view, setView] = useState('list');
    const [selectedShipment, setSelectedShipment] = useState(null);

    const handleCreateNew = () => {
        setSelectedShipment(null);
        setView('form');
    };

    const handleViewShipment = (shipment) => {
        setSelectedShipment(shipment);
        setView('form');
    };

    const handleBackToList = () => {
        setSelectedShipment(null);
        setView('list');
    };

    return (
        <div className="h-full">
            {view === 'list' ? (
                <AddressList
                    onBack={handleBackToList}
                    onCreateNew={handleCreateNew}
                    onViewShipment={handleViewShipment}
                />

            ) : (
                <AddressForm
                    onBack={handleBackToList}
                    bookingData={selectedShipment}
                />
            )}
        </div>
    );
};

export default AddressBooking;
